import { useEffect, useRef } from "react"
import { useNavigate } from "react-router-dom"

/**
 * Redirects to the given path when beId changes after initial mount.
 * Use on detail pages that are scoped to a specific business entity,
 * so switching accounts in the sidebar navigates back to the list.
 *
 * @param {string} beId - The current beId from useParams()
 * @param {string} redirectPath - The path to navigate to on beId change
 */
const useRedirectOnBeIdChange = (beId, redirectPath) => {
    const navigate = useNavigate()
    const initialBeIdRef = useRef(beId)
    const beIdChanged = beId !== initialBeIdRef.current

    useEffect(() => {
        if (beIdChanged) {
            navigate(redirectPath)
        }
    }, [beIdChanged, navigate, redirectPath])

    return beIdChanged
}

export default useRedirectOnBeIdChange
